import { useCurrentConversationId } from 'features/messaging'
import { Navigate } from 'react-router-dom'

export function MailboxPage() {
	const id = useCurrentConversationId()

	return <Navigate to={`/messaging/thread/${id}`} />
}
